export default Object.freeze({
    YIELD: 'YIELD',
    ABSOLUTE: 'ABSOLUTE'
});
